import { view, hdrm } from '@yola/ws-sdk';

const getGalleryElementByIndex = (elementId, index) => {
  const galleryContainer = view.accessors.getLiveElement(elementId);
  const galleryElements = galleryContainer.querySelectorAll(hdrm.constants.IMAGE_SELECTOR);
  return galleryElements && galleryElements[index];
};

export default getGalleryElementByIndex;
